import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import AuthService from "services/auth";
import Constants from "app_constants";
import Utils from "utils";
import RegisterView from "./view";

class Register extends Component {
  state = {
    type: null,
    email: "",
    password: "",
    name: "",
    location: "",
    website: "",
    companySize: "",
    logo: {},
    error: false,
  };

  selectType = (type) => this.setState({ type });

  setFormData = (type, value) => this.setState({ [type]: value });

  register = () => {
    const {
      email,
      logo,
      password,
      name,
      location,
      type,
      companySize,
      website,
    } = this.state;

    if (
      !Utils.validator(email) ||
      !Utils.validator(password) ||
      !Utils.validator(name) ||
      !Utils.validator(type)
    ) {
      this.setState({ error: Constants.errors.auth });
    } else {
      AuthService.register({
        email,
        logo,
        password,
        name,
        location,
        type,
        companySize,
        website,
      }).then((res) => {
        if (res === "success") this.props.history.push("/?registered=true");
        else {
          this.setState({ error: Constants.errors.general });
        }
      });
    }
  };

  render() {
    const { type, email, password, name, location, error, logo } = this.state;

    return (
      <RegisterView
        type={type}
        selectType={this.selectType}
        email={email}
        password={password}
        register={this.register}
        name={name}
        location={location}
        setFormData={this.setFormData}
        error={error}
        logo={logo.name}
      />
    );
  }
}

export default withRouter(Register);
